import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M0,0h1v0.5h-1zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['horse', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-2,-6h0.5v1h-0.5zM-1,-1.5h1v2h-1zM2,-1.5h0.5v1h-0.5zM2,-0.5h1v1h-1z',
    },
    {
      paint: 'trunk',
      d: 'M-2.5,-5h1v0.5h-1zM-3,-4.5h1v1h-1zM-2.5,-3.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v1h-0.5zM2.5,-2.5h1v2h-1zM3,-0.5h0.5v0.5h-0.5zM-2.5,0h1v0.5h-1zM1,0h1v0.5h-1z',
    },
    {
      paint: 'horse',
      d: 'M-3,-6h0.5v1.5h-0.5zM-1.5,-6h0.5v0.5h-0.5zM1.5,-4h0.5v0.5h-0.5zM0.5,-3.5h2v0.5h-2zM-2.5,-3h5v1h-5zM-2,-2h4.5v0.5h-4.5zM-2.5,-1.5h1.5v0.5h-1.5zM0.5,-1.5h1.5v0.5h-1.5zM-2.5,-1h1v1h-1zM1,-1h1v1h-1z',
    },
    {
      paint: [
        ['horse', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-2.5,-7h0.5v0.5h-0.5zM-1.5,-7h0.5v0.5h-0.5zM-2.5,-6.5h1.5v0.5h-1.5zM-1.5,-5.5h0.5v0.5h-0.5zM-1.5,-5h1v0.5h-1zM-2,-4.5h1.5v0.5h-1.5zM-2,-4h3.5v0.5h-3.5zM-2,-3.5h2.5v0.5h-2.5z',
    },
    { paint: 'fence', d: 'M-2.5,-6h0.5v1h-0.5z' },
  ],
  pixels: 118,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-0.5,0h0.5v0.5h-0.5zM0.5,0h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5z' },
    {
      paint: [
        ['horse', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-2,-6h0.5v1h-0.5zM-1,-1.5h1v1h-1zM1.5,-1.5h0.5v0.5h-0.5zM1.5,-1h1v0.5h-1zM3.5,-1h0.5v0.5h-0.5zM-4,-0.5h1v0.5h-1zM-0.5,-0.5h1v0.5h-1zM1.5,-0.5h1.5v0.5h-1.5zM0,0h0.5v0.5h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-2.5,-5h1v0.5h-1zM-3,-4.5h1v1h-1zM2,-4h1v0.5h-1zM-2.5,-3.5h0.5v0.5h-0.5zM2.5,-3.5h1.5v0.5h-1.5zM2.5,-3h2v0.5h-2zM3,-2.5h1.5v0.5h-1.5zM3.5,-0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'horse',
      d: 'M-3,-6h0.5v1.5h-0.5zM-1.5,-6h0.5v0.5h-0.5zM1.5,-4h0.5v0.5h-0.5zM0.5,-3.5h2v0.5h-2zM-2.5,-3h5v0.5h-5zM-2.5,-2.5h5.5v1h-5.5zM-2.5,-1.5h1.5v0.5h-1.5zM0.5,-1.5h1v0.5h-1zM2,-1.5h1.5v0.5h-1.5zM-3,-1h1.5v0.5h-1.5zM2.5,-1h1v0.5h-1zM-3,-0.5h1v0.5h-1zM-3.5,0h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['horse', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-2.5,-7h0.5v0.5h-0.5zM-1.5,-7h0.5v0.5h-0.5zM-2.5,-6.5h1.5v0.5h-1.5zM-1.5,-5.5h0.5v0.5h-0.5zM-1.5,-5h1v0.5h-1zM-2,-4.5h1.5v0.5h-1.5zM-2,-4h3.5v0.5h-3.5zM-2,-3.5h2.5v0.5h-2.5z',
    },
    { paint: 'fence', d: 'M-2.5,-6h0.5v1h-0.5z' },
  ],
  pixels: 123,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['horse', 0.78],
        ['shadow', 0.22],
      ],
      d: 'M-1.5,-4h0.5v0.5h-0.5zM-2.5,-2.5h0.5v0.5h-0.5zM0.5,-1.5h0.5v0.5h-0.5zM2,-1.5h0.5v2h-0.5z',
    },
    {
      paint: 'trunk',
      d: 'M-1,-7h0.5v0.5h-0.5zM-1.5,-6.5h0.5v0.5h-0.5zM-2,-6h1v2h-1zM2,-3h0.5v0.5h-0.5zM2,-2.5h1v0.5h-1zM2,-2h1.5v0.5h-1.5zM2.5,-1.5h0.5v0.5h-0.5zM2.5,-1h1v0.5h-1zM1,0h1v0.5h-1z',
    },
    {
      paint: 'horse',
      d: 'M-2,-7.5h1v1h-1zM-3,-7h0.5v0.5h-0.5zM-3,-6.5h1.5v0.5h-1.5zM-1,-5h0.5v1h-0.5zM0.5,-4.5h0.5v0.5h-0.5zM-1,-4h3v0.5h-3zM-2.5,-3.5h4.5v0.5h-4.5zM-3,-3h5v0.5h-5zM-0.5,-2.5h2.5v1h-2.5zM1,-1.5h1v1.5h-1z',
    },
    {
      paint: [
        ['horse', 0.7],
        ['snowCap', 0.3],
      ],
      d: 'M-2.5,-8h1.5v0.5h-1.5zM-2.5,-7.5h0.5v0.5h-0.5zM-1,-6.5h0.5v0.5h-0.5zM-1,-6h1v1h-1zM-0.5,-5h1v1h-1z',
    },
    { paint: 'fence', d: 'M-2.5,-7h0.5v0.5h-0.5z' },
  ],
  pixels: 94,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
